module.exports = {
  title: '满赠活动详情',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'gifts-activity-detail',
    },
  },
};
